/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Visibility_Price_PrefixInputs */

const et_plan_visibility_price_prefix = /** @type {(inputs: Plan_Visibility_Price_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alates`)
};

const en_plan_visibility_price_prefix = /** @type {(inputs: Plan_Visibility_Price_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From`)
};

/**
* | output |
* | --- |
* | "From" |
*
* @param {Plan_Visibility_Price_PrefixInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_visibility_price_prefix = /** @type {((inputs?: Plan_Visibility_Price_PrefixInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Visibility_Price_PrefixInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_visibility_price_prefix(inputs)
	return en_plan_visibility_price_prefix(inputs)
});